import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function PraesenzIcon({
	width = 12,
	height = 16,
	color = 'currentColor',
	style,
	active = false,
	customIconColor,
	...rest
}: IconRenderProps): ReactElement {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 12 16"
			fill="none"
			aria-hidden="true"
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<path
				d="M6 7.40723C7.55229 7.40723 8.99037 7.62525 10.1055 8.21094L10.3115 8.32715C11.3206 8.93268 12.0009 9.92721 12.001 11.2109V14.4209C12.0009 14.6666 11.845 14.8832 11.6143 14.9727V14.9736H11.6123C11.6109 14.9742 11.609 14.9756 11.6064 14.9766C11.6012 14.9786 11.5931 14.9816 11.583 14.9854C11.5626 14.993 11.5323 15.0035 11.4932 15.0176C11.4146 15.0458 11.2996 15.0866 11.1523 15.1348C10.8577 15.2313 10.4337 15.3598 9.91797 15.4883C8.887 15.7451 7.48382 16.002 6 16.002C4.51618 16.0023 3.113 15.7452 2.08203 15.4883C1.56651 15.3598 1.14327 15.2313 0.848633 15.1348C0.701301 15.0865 0.585386 15.0459 0.506836 15.0176C0.467798 15.0035 0.437295 14.993 0.416992 14.9854C0.407222 14.9817 0.399724 14.9785 0.394531 14.9766C0.392143 14.9756 0.39001 14.9741 0.388672 14.9736H0.386719C0.154242 14.8842 6.21373e-05 14.6654 0 14.4209V11.2109C9.17167e-05 9.84075 0.772292 8.80014 1.89355 8.21094C3.0084 7.62521 4.44775 7.40725 6 7.40723ZM6 8.59473C4.56737 8.59473 3.31182 8.81912 2.47852 9.25684C2.06169 9.47615 1.74979 9.72682 1.54199 10.0381C1.33486 10.3485 1.22562 10.7274 1.22559 11.2109V13.9873C1.76762 14.1786 3.69975 14.8144 6 14.8145C8.2996 14.8145 10.2316 14.1787 10.7744 13.9873V11.2109C10.7744 10.7281 10.6651 10.3495 10.458 10.0391C10.25 9.72761 9.93796 9.47617 9.52051 9.25684V9.25586C8.68858 8.81741 7.43296 8.59473 6 8.59473ZM5.99902 0C7.88648 0 9.43453 1.48363 9.43457 3.30957C9.43443 5.13542 7.88664 6.62012 5.99902 6.62012C4.11165 6.61983 2.56459 5.13525 2.56445 3.30957C2.56449 1.48381 4.11181 0.000288533 5.99902 0ZM5.99902 1.1875C4.76916 1.18778 3.79008 2.13498 3.79004 3.30957C3.79017 4.48408 4.76922 5.43136 5.99902 5.43164C7.22906 5.43164 8.20787 4.48346 8.20801 3.30957C8.20797 2.13561 7.22912 1.1875 5.99902 1.1875Z"
				fill={color}
			/>
		</svg>
	);
}
